import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import SearchFilter from '../Reusable/SearchFilter';
import withTranslations from '../../utils/HighOrderComponent';
import PlaceRow from './PlaceRow';
import Tooltip from '@material-ui/core/Tooltip';
import ModalForAddOrUpdatePlace from './ModalForAddOrUpdatePlace';
import { Link } from 'react-router-dom';

class PlaceTable extends Component {
  constructor() {
    super();
    this.state = {
      showModalForAddPlace: false,
    };
  }

  showModal = (e) => {
    this.setState({
      showModalForAddPlace: true,
    });
  };

  handlePreviewClose = () => {
    this.setState({
      showModalForAddPlace: false,
    });
  };

  handleAddPlace = (place) => {
    const { NotificationMessages } = this.props.t;
    this.props.createPlace(
      place,
      this.handlePreviewClose,
      NotificationMessages
    );
  };

  render() {
    const { t, updatePlace } = this.props || {},
      { HeaderColumns, titleTable, Tooltips } = t || {};
    const placeList = this.props.placeList?.map((place, index) => (
      <PlaceRow
        index={index + 1}
        key={place.id}
        place={place}
        updatePlace={updatePlace}
        translations={t}
      />
    ));

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
                <Col className="col-md-3">
                  <SearchFilter noSearchColums={0} />
                </Col>
                <Col className="col-md-1 text-right">
                  <Link id="addPlace" onClick={this.showModal} to="#">
                    <Tooltip
                      title={Tooltips.addPlace}
                      placement="top"
                      arrow={true}
                    >
                      <i className="fas fa-plus fa-2x" />
                    </Tooltip>
                  </Link>
                </Col>
              </Row>
            </Card.Header>
            <Table responsive hover id="table">
              <thead>
                <tr className=" text-center">
                  <th className="align-top" width="4%">
                    #
                  </th>
                  <th className="align-top">{HeaderColumns.name}</th>
                  <th className="align-top">
                    {HeaderColumns.autonomousProvince}
                  </th>
                  <th className="align-top">
                    {HeaderColumns.addAutonomousProvince}
                  </th>
                  <th className="align-top">{HeaderColumns.updatePlace}</th>
                </tr>
              </thead>
              <tbody>{placeList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return (
      <Fragment>
        {table}
        {this.state.showModalForAddPlace && (
          <ModalForAddOrUpdatePlace
            show={this.state.showModalForAddPlace}
            handleClose={this.handlePreviewClose}
            createPlace={this.handleAddPlace}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(PlaceTable, 'PlaceTable');
